import React from 'react';

// Company bank accounts printed on every customer document (invoice, quotation, pro forma).
export const BANK_ACCOUNTS = [
  { bank: 'Sampath Bank PLC', branch: 'Pettah', type: 'Current Account', number: '021710004207' },
  { bank: 'Nations Trust Bank', branch: 'Pettah Main Street', type: 'LKR Current Account', number: '100080026041', swift: 'NTBCLKLX' },
];

export default function PaymentDetails({ style }) {
  return (
    <div style={{ borderTop: '2px solid #f07040', paddingTop: 16, ...style }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#f07040', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>Payment Details</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        {BANK_ACCOUNTS.map(b => (
          <div key={b.number} style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '4px 20px', fontSize: 12, alignContent: 'start' }}>
            <span style={{ color: '#888' }}>Account Name</span><span style={{ fontWeight: 600 }}>Travelscape Lanka Pvt Ltd</span>
            <span style={{ color: '#888' }}>Bank</span><span style={{ fontWeight: 600 }}>{b.bank}</span>
            <span style={{ color: '#888' }}>Branch</span><span style={{ fontWeight: 600 }}>{b.branch}</span>
            <span style={{ color: '#888' }}>Account Type</span><span style={{ fontWeight: 600 }}>{b.type}</span>
            <span style={{ color: '#888' }}>Account Number</span><span style={{ fontWeight: 700, fontSize: 13, fontFamily: 'monospace', color: '#1a1a2e' }}>{b.number}</span>
            {b.swift && <><span style={{ color: '#888' }}>SWIFT Code</span><span style={{ fontWeight: 600, fontFamily: 'monospace' }}>{b.swift}</span></>}
          </div>
        ))}
      </div>
    </div>
  );
}
